import { getEnvConfig } from 'utils/getEnvConfig'
import {
  apiRequestInterceptor,
  apiResponseErrorInterceptor,
  apiResponseSuccessInterceptor,
  businessIdInterceptor
} from './apiInterceptor'
import ApiService from './ApiService'

const GENERATE_USER_STATEMENT_ENDPOINT = '/report/v2/report'

const headers = {
  'content-type': 'application/json',
  accept: 'application/json, text/plain, */*'
}

const endpoint = `${getEnvConfig('WEB_BASE_URL')}/ledger`

const api = new ApiService(endpoint, headers)
const apiV2 = new ApiService(endpoint.replace('v1', 'v2'), headers)

api.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
api.requestInterceptor(businessIdInterceptor, (error: any) => console.error(error))
api.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

apiV2.requestInterceptor(apiRequestInterceptor, (error: any) => console.error(error))
apiV2.responseInterceptor(apiResponseSuccessInterceptor, apiResponseErrorInterceptor)

export const generateTransactionReportId = (payload: {
  device_id: string
  account_id: string
  start_time?: number
  end_time?: number
  type: string
  lang: string
}) => api.postRequest(GENERATE_USER_STATEMENT_ENDPOINT, payload)

export const generateTransactionReport = (reportId: string) => {
  return api.getRequest(`${GENERATE_USER_STATEMENT_ENDPOINT}?report-id=${reportId}`, {})
}

export const CustomerSupplierReportApi = {
  generateTransactionReport,
  generateTransactionReportId
}
